import React, { FC } from 'react';
import { Note } from 'components/ui';
import { hexColorRegex, t } from 'utils';

import styles from './AppIcon.module.scss';
import { Field } from 'react-final-form';
import { TextInputWrapper, ColorSelectWrapper } from 'components/forms';
import { IAppIcon } from './AppIcon';
import classNames from 'classnames';

// export interface IAppIconFontAwesome extends HTMLAttributes<HTMLDivElement> {
//   iconFontAwesomeName: string;
//   iconTextColor: string;
//   iconBackgroundColor: string;
//   isFormDisabled?: boolean;
// }

const AppIconFontAwesome: FC<IAppIcon> = ({
  errors = {},
  disabled,
  iconTextColor,
  iconFontAwesomeName,
  iconBackgroundColor,
}) => {
  const isValidBackgroundColor = hexColorRegex.test(iconBackgroundColor);
  const isValidTextColor = hexColorRegex.test(iconTextColor);
  const defaultBackgroundColor = '#E5E6E7';
  const defaultTextColor = '#FFFFFF';
  const bgColorToUse = isValidBackgroundColor ? iconBackgroundColor : defaultBackgroundColor;

  return (
    <div className={styles['ta-app-icon__form']}>
      <div
        className={classNames(styles['ta-app-icon__form__icon-preview'], {
          [styles['ta-app-icon__form__icon-preview__white']]: ['#fff', '#ffffff'].includes(
            bgColorToUse.toLowerCase()
          ),
        })}
        style={{ backgroundColor: bgColorToUse }}
      >
        <span
          style={{ color: isValidTextColor ? iconTextColor : '#ffffff' }}
          className={`fas fa-${iconFontAwesomeName ?? 'user-circle'}`}
        />
      </div>
      <Field
        name='iconFontAwesomeName'
        component={TextInputWrapper}
        disabled={disabled}
        required
        error={errors.abbreviatedName}
        label='app.icon.box.fontawesome.name.label'
        placeholder='app.icon.box.fontawesome.name.placeholder'
        className={styles['ta-app-icon__form__input']}
        parse={(value) => value} // needed because if deleted, final-form does not pass the empty srting
      />
      <Field
        name='iconBackgroundColor'
        component={ColorSelectWrapper}
        disabled={disabled}
        required
        defaultColor={defaultBackgroundColor}
        label='app.icon.box.fontawesome.background.label'
        placeholder='app.icon.box.fontawesome.background.placeholder'
        className={styles['ta-app-icon__form__input']}
        parse={(value) => value}
      />
      <Field
        name='iconTextColor'
        component={ColorSelectWrapper}
        disabled={disabled}
        required
        defaultColor={defaultTextColor}
        label='app.icon.box.fontawesome.color.label'
        placeholder='app.icon.box.fontawesome.color.placeholder'
        className={styles['ta-app-icon__form__input']}
        parse={(value) => value}
      />
      <Note className={styles['ta-app-icon__form__note']}>
        <span
          dangerouslySetInnerHTML={{
            __html: t('app.icon.fontawesome.hint'),
          }}
        />
      </Note>
    </div>
  );
};

export default AppIconFontAwesome;
